export default __webpack_public_path__ + "static/media/00.8f09e4ca.jpg";